import { Component, inject } from '@angular/core';
import { CertificationCodeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CertificationCodeCreateDto,
  CertificationCodeDto,
  CertificationCodeExcelDownloadDto,
  CertificationCodeUpdateDto,
} from '../proxy/planning/dtos/certification-code';
import { CERTIFICATIONCODE_CONFIG, CERTIFICATIONCODE_FIELDS } from './certification-code.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-certification-code',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CertificationCodeService, ConfirmationService],
  templateUrl: './certification-code.html',
  styleUrl: './certification-code.scss',
})
export class CertificationCode extends BaseCrudComponent<
  CertificationCodeDto,
  CertificationCodeCreateDto,
  CertificationCodeUpdateDto,
  CertificationCodeExcelDownloadDto
> {
  service = inject(CertificationCodeService);
  config = CERTIFICATIONCODE_CONFIG;
  fields = CERTIFICATIONCODE_FIELDS;

  protected prepareUpdateDto(data: any, selected: CertificationCodeDto): CertificationCodeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CertificationCode';
  }
}
